import styled from 'styled-components';

export const MediaWrapper = styled.section``;
